import * as COM from '../components';
const potentialMember = [
  /** ------------------------------ 会员列表 ------------------------------ */
  {
    path: '/potential-member',
    component: COM.Layout,
    redirect: '/potential-member/index',
    name: 'potential__potentialMember',
    meta: { label: '潜在会员列表' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 会员列表
      {
        path: 'index',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.PotentialMemberListIndex,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'potentialMemberListIndex',
        meta: { label: '潜在会员列表', icon: 'el-icon-document', menuKeyPath: '/potential-member/index' }
      },
      // 会员详情
      {
        path: '/potential-member/index',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/potential-member/index/detail',
        name: 'potentialmemberListdetailInside',
        meta: { label: '潜在会员列表', insidePageFrom: 'potentialMemberListIndex' },
        children: [
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.PotentialMemberListDetail
            },
            name: 'potentialMemberListDetail',
            meta: { label: '会员详情', icon: 'el-icon-document', menuKeyPath: '/potential-member/index', authKey: 'potentialMemberListIndex' }
          },
        ]
      }
    ]
  }
];

export default potentialMember;
